export function clamp(v: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, v));
}

export function median(arr: number[]): number {
  if (arr.length === 0) return 0;
  const s = [...arr].sort((a, b) => a - b);
  const m = Math.floor(s.length / 2);
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
}

export function mad(arr: number[]): number {
  const med = median(arr);
  return median(arr.map((v) => Math.abs(v - med)));
}

export function robustZ(value: number, med: number, madVal: number): number {
  const sigma = 1.4826 * madVal;
  if (sigma < 1e-6) return 0;
  return (value - med) / sigma;
}

export function timeStr(ts: number): string {
  const d = new Date(ts);
  return d.toTimeString().slice(0, 8);
}

export function fmtTimer(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** headVector [x, y, z] → yaw (degrees).
 * Guards a malformed/short vector (audit C1): a length<3 array made hv[2]
 * undefined → atan2(...,NaN) → NaN, which silently poisons every downstream
 * gaze comparison (all become false → misclassified as `forward`). Returns 0
 * for an ill-formed vector so the caller sees a neutral, finite value. */
export function headVectorToYaw(hv: number[]): number {
  if (!hv || hv.length < 3 || !Number.isFinite(hv[0]) || !Number.isFinite(hv[2])) return 0;
  return Math.atan2(hv[0], -hv[2]) * (180 / Math.PI);
}

/** headVector [x, y, z] → pitch (degrees). Same finite-guard as yaw (audit C1). */
export function headVectorToPitch(hv: number[]): number {
  if (!hv || hv.length < 2 || !Number.isFinite(hv[1])) return 0;
  return Math.asin(clamp(hv[1], -1, 1)) * (180 / Math.PI);
}

let _eventId = 0;
export function nextEventId(): string {
  return `ev-${++_eventId}`;
}
